module.exports = __webpack_public_path__ + "img/icon-call.0cf0cfb4.svg";